import React, { useState, useRef, useEffect } from 'react';
import { useLanguage } from '../../contexts/LanguageContext';

export default function LanguageSelector() {
  const { language, changeLanguage } = useLanguage();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const languages = [
    { code: 'en', name: 'English', flag: '🇺🇸' },
    { code: 'es', name: 'Español', flag: '🇪🇸' }
  ];

  const currentLanguage = languages.find(lang => lang.code === language);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleLanguageChange = (langCode) => {
    changeLanguage(langCode);
    setIsOpen(false);
  };

  return (
    <div className="relative inline-block" ref={dropdownRef}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="lg:text-white lg:hover:text-blueGray-200 text-blueGray-700 px-3 py-4 lg:py-2 flex items-center text-xs uppercase font-bold transition-all duration-150"
        aria-label="Select language"
        aria-expanded={isOpen}
      >
        <span className="text-lg mr-2">{currentLanguage?.flag}</span>
        <span className="hidden lg:inline">{currentLanguage?.code.toUpperCase()}</span>
        <i className={`fas fa-chevron-down ml-2 text-xs transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`}></i>
      </button>

      {isOpen && (
        <div className="absolute right-0 mt-2 w-48 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 z-50">
          <div className="py-1" role="menu" aria-orientation="vertical">
            {languages.map((lang) => (
              <button
                key={lang.code}
                onClick={() => handleLanguageChange(lang.code)}
                className={`w-full text-left px-4 py-2 text-sm flex items-center hover:bg-blueGray-100 transition-colors duration-150 ${
                  language === lang.code ? 'bg-blueGray-50 font-semibold' : ''
                }`}
                role="menuitem"
              >
                <span className="text-xl mr-3">{lang.flag}</span>
                <span className="text-blueGray-700">{lang.name}</span>
                {language === lang.code && (
                  <i className="fas fa-check ml-auto text-lightBlue-500"></i>
                )}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
